module.exports = __webpack_public_path__ + "img/06.70a48e4b.png";